module.exports = "<div class=\"help\" ng-if=\"helpText\">\n    <div\n        class=\"infobut\"\n        uib-tooltip-html=\"helpText\"\n        tooltip-placement=\"auto {{getPosition()}}\"\n        tooltip-class=\"infotext\"\n        tooltip-trigger=\"'outsideClick'\"\n        title=\"{{'quoteandbind.directives.templates.offer-actions-button-bar.Help.title' | translate}}\"\n        ng-include=\"'/qnb/styles/images/icons/icon-info-circle.svg'\"\n    ></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/basler/templates/basler-info-link.html
// module id = 544
// module chunks = 0